import type { ISODateTime } from '../../../../types/common';

export const isExpired = (expiresOn: ISODateTime) => {
  const now = new Date().getTime();
  return new Date(expiresOn).getTime() < now;
};
